<template>
  <div class="asset-card">
    <el-tooltip
      :key="showTable ? 'shown' : 'hidden'"
      :content="$t('tooltip.listOfTags')"
      :disabled="showTable"
      :hide-after="2500"
    >
      <el-card shadow="hover">
        <div slot="header" @click="showTable = !showTable">
          <div class="head">
            <div class="head__icon">
              <div v-if="tagsType == 'Inside'" class="asset-icon">
                <img
                  class="inside-icon"
                  src="@/assets/map-pin-check-inside.svg"
                  :alt="$t('alt.inside')"
                />
              </div>
              <div v-else-if="tagsType == 'Outside'" class="asset-icon">
                <img
                  class="outside-icon"
                  src="@/assets/map-pin-x-inside.svg"
                  :alt="$t('alt.outside')"
                />
              </div>
              <div v-else-if="tagsType == 'Warning'" class="asset-icon">
                <img
                  class="warning-icon"
                  src="@/assets/warning.svg"
                  :alt="$t('alt.warning')"
                />
              </div>
              <div v-else-if="tagsType == 'Undefined'" class="asset-icon">
                <img
                  class="undefined-icon"
                  src="@/assets/map-pin-off.svg"
                  :alt="$t('alt.undefined')"
                />
              </div>
              <div class="stats-trending">
                <span class="trending" v-if="trendingUp || trendingDown">
                  <div v-if="trendingUp">
                    <img
                      class="trending-up-icon"
                      src="@/assets/trending-up.svg"
                      :alt="$t('alt.trendingUp')"
                    />
                  </div>
                  <div v-else-if="trendingDown">
                    <img
                      class="trending-down-icon"
                      src="@/assets/trending-down.svg"
                      :alt="$t('alt.trendingDown')"
                    />
                  </div>
                </span>
                <span class="percentage"
                  ><b>{{ percentage }} %</b></span
                >
              </div>
            </div>
            <div class="head__title">
              <span class="quantity">{{ tagList.length }}</span>
              <span class="tags-type"> {{ tagsType }}</span>
            </div>
          </div>
          <span class="footer">
            {{ $t("labels.lastChange") }}: {{ lastChange }}
            <i class="el-icon-caret-right" v-if="!showTable"></i>
            <i class="el-icon-caret-bottom" v-else></i>
          </span>
        </div>
        <div class="content-table" v-if="showTable">
          <div v-if="!tagList?.length" class="no-data">
            <span>{{ $t("labels.noData") }}</span>
          </div>
          <el-table
            v-else
            :data="tagList"
            class="custom-table"
            height="fit-content"
          >
            <template slot="empty">
              {{ $t("labels.noData") }}
            </template>
            <el-table-column
              prop="label"
              :label="$tc('labels.tag', 1)"
              align="center"
              sortable
              width="97"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.label">
                  {{ scope.row.label }}
                </template>
                <template v-else>
                  <span>{{ toHex(scope.row.tagId) }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="lastSeenTs"
              :label="$t('labels.lastSeen')"
              align="center"
              sortable
              width="100"
            >
              <template slot-scope="scope">
                <template>
                  {{ formatHour(scope.row.lastSeenTs) }}
                  <span
                    v-if="
                      scope.row.lastSeenTs &&
                        isDateBeforeToday(scope.row.lastSeenTs, clientData)
                    "
                  >
                    <el-tooltip placement="top">
                      <div slot="content">
                        {{ formatDate(scope.row.lastSeenTs) }}
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="anchorLabel"
              :label="$t('labels.label')"
              align="center"
              sortable
              width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.anchorLabel }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-tooltip>
  </div>
</template>
<script>
import moment from "moment-timezone";
import { mapState } from "vuex";
import { isDateBeforeToday } from "@/utils/utils";

export default {
  name: "AssetCard",
  props: {
    tagList: {
      type: Array,
      default: () => []
    },
    percentage: {
      type: Number,
      default: 0
    },
    tagsType: {
      type: String,
      default: ""
    },
    toHex: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      moment,
      isDateBeforeToday,
      lastChange: "",
      showTable: false,
      trendingDown: false,
      trendingUp: false
    };
  },
  computed: {
    ...mapState("clients", {
      clientData: "data"
    })
  },
  methods: {
    formatHour(lastSeenTs) {
      return lastSeenTs
        ? moment
            .tz(moment.unix(lastSeenTs), this.clientData.timezone)
            .format("LTS")
        : "";
    },

    formatDate(lastSeenTs) {
      return moment
        .tz(moment.unix(lastSeenTs), this.clientData.timezone)
        .format("LLL");
    }
  },
  created() {
    this.lastChange = moment
      .tz(moment(), this.clientData.timezone)
      .format("LTS");
  },
  watch: {
    tagList: {
      handler(newValue, oldValue) {
        if (newValue.length > oldValue.length) {
          this.lastChange = moment
            .tz(moment(), this.clientData.timezone)
            .format("LTS");
          this.trendingUp = true;
          this.trendingDown = false;
        } else if (newValue.length < oldValue.length) {
          this.lastChange = moment
            .tz(moment(), this.clientData.timezone)
            .format("LTS");
          this.trendingUp = false;
          this.trendingDown = true;
        }
      }
    }
  }
};
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.asset-card {
  .el-card {
    width: 360px;
    min-height: 129px;
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    cursor: pointer;

    @media (max-width: 579px) {
      width: 73vw;
    }

    &__header {
      padding: 0;
      border-bottom: none;

      .head {
        display: flex;
        flex-direction: column;
        padding: 12px;
        gap: 18px;

        &__icon {
          display: flex;
          justify-content: space-between;

          .stats-trending {
            display: flex;
            gap: 5px;

            .percentage {
              font-size: 14px;
            }
          }

          .asset-icon {
            display: flex;
            justify-content: center;
            padding: 5px 6px;
            background-color: #ebeef5;
            border-radius: 8px;
          }
        }
        &__title {
          text-align: left;

          .quantity {
            font-size: 40px;
            word-break: break-all;
          }
          .tags-type {
            font-size: 18px;
            color: #545454;
            font-weight: bold;
          }
        }
      }

      .footer {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        text-align: start;
        color: #606266;
        padding: 0 12px 12px;
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      gap: 5px;
      padding: 0;

      .content-table {
        padding: 0 20px 16px;

        .no-data {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 60px;
          font-size: 12px;
          font-weight: bold;
          color: #c0c4ce;
        }
        .custom-table {
          overflow-y: auto;
          max-height: 250px;
          font-size: 12px !important;

          @media (max-width: 1630px) {
            max-height: 300px !important;
          }

          .highlight {
            background-color: #fff583 !important;
          }

          .el-icon-info {
            color: #e6a23c;
          }
        }
      }
    }

    .el-table {
      border-collapse: separate;
      border-spacing: 0;
      width: 100%;

      &::before {
        content: none;
        border: none !important;
      }

      .el-table__body {
        td {
          border: none;
          padding: 3px;
        }

        th {
          border: none;
        }
      }
      .el-table__header-wrapper {
        th {
          padding: 2px 0 5px;
        }
      }
    }
  }
}
</style>
